import React, { useEffect, useRef, useState } from "react";
import { Form, Spin, Modal, Input, Select, Tag, Radio } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import svg40 from "../../../../assets/svg/svg40.svg";
import { schemeSetupCateData, schemeSetupTypeData } from "../../../../data";
import { useWatch } from "antd/es/form/Form";

const { TextArea } = Input;
const SchemeKpiAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const urlPerfomance = "performance/fetch_performances";
  const { loading, dataPerf } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataPerf: state.fetch.data[urlPerfomance] || [],
  }));

  const plainOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];
  const onFinish = async (data) => {
    data.metrId = prodd?.metrId ? prodd?.metrId : null;
    data.metrDesc = Array.isArray(data?.metrDesc)
      ? data?.metrDesc.join(",")
      : data?.metrDesc;
    const res = await dispatch(
      save({
        ...data,
        url: "performance_metric/save_performancemetric",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const [blocks, setBlocks] = useState([]);

  const [inputValue, setInputValue] = useState("");

  const handleAddBlock = () => {
    if (inputValue.trim() && !blocks.includes(inputValue)) {
      const newBlocks = [...blocks, inputValue];
      setBlocks(newBlocks);
      setInputValue("");
      form.setFieldsValue({ metrDesc: newBlocks });
    }
  };

  const handleRemoveBlock = (block) => {
    const newBlocks = blocks.filter((b) => b !== block);
    setBlocks(newBlocks);
    form.setFieldsValue({ metrDesc: newBlocks });
  };

  useEffect(() => {
    if (prodd?.metrDesc) {
      setBlocks(prodd?.metrDesc?.split(",")?.map((b) => b?.trim()));
    }
  }, [prodd, form]);

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]);
  const metrUnit = useWatch("metrUnit", form);

  return (
    <Modal
      title={`${prodd?.metrId ? "Update Metric" : "Add Metric"}`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[49.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <Form.Item
          name="metrPerfId"
          className=""
          label={"Perfomance"}
          rules={[
            {
              required: true,
              message: "Please select Perfomance",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataPerf?.length > 0 &&
              dataPerf?.map((item) => ({
                value: item?.perfId,
                label: item?.perfName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="metrType"
          className=""
          label={"Category"}
          rules={[
            {
              required: true,
              message: "Please select category",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              schemeSetupCateData?.length > 0 &&
              schemeSetupCateData?.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="metrUnit"
          className=""
          label={"Type"}
          rules={[
            {
              required: true,
              message: "Please select type",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              schemeSetupTypeData?.length > 0 &&
              schemeSetupTypeData?.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        {metrUnit === "RADIO" && (
          <Form.Item
            name="metrDesc"
            label={"Options"}
            rules={[
              {
                required: true,
                message: "Please add options",
              },
            ]}
          >
            <div className="flex w-full gap-x-[1rem]">
              <Input
                className="input"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder="Type and click + to add"
                onPressEnter={handleAddBlock}
              />
              <button
                type="button"
                onClick={handleAddBlock}
                className="cstm-btn !border-none !w-[50px] !bg-white !text-darkBlue"
              >
                Add <img src={svg40} alt="svg40" />
              </button>
            </div>

            <div className="mt-[.31rem]">
              {blocks?.map((block) => (
                <Tag
                  className="rounded-[.25rem] bg-[#F1F3F5] px-[.3125rem] py-[.25rem] gap-[.25rem]"
                  key={block}
                  closable
                  onClose={() => handleRemoveBlock(block)}
                >
                  {block}
                </Tag>
              ))}
            </div>
          </Form.Item>
        )}

        <Form.Item
          name="metrLabel"
          label={"Label"}
          rules={[
            {
              required: true,
              message: "Please add label",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>

        <Form.Item
          name="metrRequired"
          label="Required"
          rules={[
            {
              required: true,
              message: "Check if its required",
            },
          ]}
        >
          <Radio.Group options={plainOptions} />
        </Form.Item>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? <Spin /> : prodd?.metrId ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default SchemeKpiAdd;
